import { getPageLabel } from '../pages';

interface GAEvent {
  category: string;
  action: string;
  label?: string;
  value?: number;
}

interface EventCreator {
  (...args: any[]): GAEvent;
}

export const event = ({ category, action, label, value }: GAEvent) => {
  if (process.env.NODE_ENV === 'development') {
    console.group(`GA Event`);
    console.log(`Category:  ${category}`);
    console.log(`Action:    ${action}`);
    console.log(`Label:     ${label}`);
    value !== undefined && console.log(`Value:     ${value}`);
    console.groupEnd();
  }

  // Note: GA 'event' won't be trigger even if pushed via data layer when both GTM container variables is off/false:
  //       - `Google Analytics - Self Service - Enabled`
  //       - `Google Analytics - Self Service Event - Enabled`.
  if (window.dataLayer && category && action) {
    window.dataLayer.push({ event: 'gaEvent', category, action, label, value });
  }
};

export function createEventCreator<T extends EventCreator>(eventCreator: T) {
  return (...args: Parameters<T>) => {
    event({ label: getPageLabel(), ...eventCreator(...args) });
  };
}
